export default __webpack_public_path__ + "static/media/chart-preview.4a59ef37.png";